import insuranceGFA from 'images/brands-unique/gfa/insurance.png';
import insuranceETN from 'images/brands-unique/etn/insuranceETN.png';
import insuranceBrasilia from 'images/brands-unique/brasilia/insuranceBrasilia.png';

import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import { getInsuranceCoverageByBrand } from '../config/insurance/brands';

const localInsuranceIcons = {
  default: insuranceETN,
  gfa: insuranceGFA,
  brasilia: insuranceBrasilia,
};

/**
 * useInsuranceConfig hook.
 * Provide insurance icon, details URL, price and resolved coverage config by brand.
 * @returns {{icon: string, detailsUrl: string|Array, price: number, coverage: object, disclaimerConfig: string|object, titleContext: string, taxRate: string}}
 */
const useInsuranceConfig = () => {
  const { insurance, brand } = useWhitelabelEnvs();
  const localInsuranceIcon = localInsuranceIcons[brand] ?? localInsuranceIcons.default;
  const coverageConfig = getInsuranceCoverageByBrand(brand, insurance?.coverages || []);

  // Determine title context based on brand
  const titleContext = brand === 'brasilia' ? 'brasilia' : 'coverage';

  return {
    icon: insurance?.icon || localInsuranceIcon,
    detailsUrl: insurance?.url || '',
    price: insurance?.price || 0,
    coverage: coverageConfig,
    disclaimerConfig: insurance?.disclaimerText || null,
    titleContext,
    taxRate: insurance?.taxRate || '0',
  };
};

export default useInsuranceConfig;
